import React, { Component } from "react";
import ReportHeader from "../../../Report/ReportHeaderMal";
import line from "../../../Images/line.jpeg";

var sectionStyle = {
  backgroundImage: `url(${line})`
};

class ReceiptEntry extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <>
        <div className="p-2 border border-dark">
          <ReportHeader onCloseClick={this.onCloseClick} IsClose="0" />
          <h2 align="center">{this.getCustomText("Heading")}</h2>
          <div className="container-fluid reportFont">
            <div className="row p-3 ">
              <div className="col-3">
                Receipt # : {this.props.data.receiptNo}
              </div>
              <div className="col-6"></div>
              <div className="col-3" align="right">
                Date : {this.props.data.date}
              </div>
            </div>
            <div className="row p-1" style={sectionStyle}>
              <div className="col-3">{this.getCustomText("Name")}</div>
              <div className="col-7">{this.props.data.name}</div>
            </div>
            <div className="row p-1 " style={sectionStyle}>
              <div className="col-3">{this.getCustomText("Type")}</div>
              <div className="col-7">{this.props.data.type}</div>
            </div>
            <div className="row p-1 " style={sectionStyle}>
              <div className="col-3">Amount : </div>
              <div className="col-7">{this.props.data.amountWords}</div>
            </div>
            <div className="row p-1 ">
              <div className="p-2 border border-dark col-3" align="right">
                <h3> ₹ {this.getCustomText("Amount")} </h3>
              </div>
              <div className="col-3 align-bottom" align="right">
                Secretary
              </div>
              <div className="col-3" align="right">
                Treasurer
              </div>
              <div className="col-3" align="right">
                Receiver
              </div>
            </div>
          </div>
        </div>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
      </>
    );
  }

  onCloseClick = e => {
    this.props.onCloseClick("Filter", null);
  };

  getCustomText = type => {
    if (this.props.data.txntype === "Income") {
      switch (type) {
        case "Heading":
          return "Receipt";
        case "Name":
          return "Received From : ";
        case "Type":
          return "Towards : ";
        case "Amount":
          return this.props.data.amount;
      }
    } else {
      switch (type) {
        case "Heading":
          return "Voucher";
        case "Name":
          return "Name : ";
        case "Type":
          return "For The Purpose : ";
        case "Amount":
          return this.props.data.amount * -1;
      }
    }
  };
}

export default ReceiptEntry;
